import React from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      minHeight: 'calc(100vh - 200px)' 
    }}>
      <Paper sx={{ p: 5, textAlign: 'center', maxWidth: 500, borderRadius: 2 }} elevation={0}>
        <Typography variant="h1" sx={{ fontSize: '5rem', fontWeight: 700, color: '#3f51b5', mb: 2 }}>
          404
        </Typography>
        <Typography variant="h4" gutterBottom>
          Page Not Found
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          The page you are looking for doesn't exist or has been moved.
        </Typography>
        <Button 
          variant="contained" 
          startIcon={<HomeIcon />}
          onClick={() => navigate('/')}
          sx={{ 
            bgcolor: '#3f51b5', 
            '&:hover': { bgcolor: '#303f9f' },
            textTransform: 'none'
          }}
        >
          Go to Homepage
        </Button>
      </Paper>
    </Box>
  );
};

export default NotFoundPage;
